module.exports = __webpack_public_path__ + "img/kkr_long.e3813b32.svg";